export default __webpack_public_path__ + "static/media/yellowFlower.080e87c7.jpg";